import { render, staticRenderFns } from "./HeaderV2UserDdItem.vue?vue&type=template&id=cca7484a&scoped=true&"
import script from "./HeaderV2UserDdItem.vue?vue&type=script&lang=ts&"
export * from "./HeaderV2UserDdItem.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderV2UserDdItem.vue?vue&type=style&index=0&id=cca7484a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca7484a",
  null
  
)

export default component.exports